// extracted by mini-css-extract-plugin
export default {"container":"Label_container__Xa8zO"};